<template>
    <div v-bind:class="{flash: confirmationShown}">
        <span class="hour-label">
            {{ hourNumber }}:00
        </span>
        <template v-if="!confirmationShown">
            <ToggleButton
                    v-bind:value="hourData.available"
                    v-on:input="onToggleInput"
                    v-bind:sync="true"
                    v-bind:color="{checked: '#a9d5f7', unchecked: '#cfcfcf'}"
                    v-bind:width="60"
                    v-bind:height="34"
                    v-bind:disabled="disabled">
            </ToggleButton>
            <div class="zone-content">
                <ZoneSelector
                        v-if="hourData.available === false"
                        v-bind:zoneId="hourData.zoneId"
                        v-on:update:zoneId="onZoneIdInput"
                        v-bind:countryCode="user.country"
                        v-bind:placeholder="zipCodeInputPlaceholder"
                        v-bind:hideLabel="true">
                </ZoneSelector>
            </div>
            <i
                    v-if="hourData.jobScheduled === true"
                    v-bind:title="warningMessage"
                    v-tippy="{arrow: true}"
                    class="fa fa-exclamation-triangle warning-icon"></i>
        </template>
        <span
                v-else
                v-bind:title="confirmationMessage"
                v-tippy="{arrow: true, trigger: 'manual', showOnLoad: true, hideOnClick: false, sticky: true}"
                v-bind:ref="'tooltip-holder'">
            <button
                    v-on:click="confirm"
                    class="btn btn-default">
                {{ 'OK' | trans }}
            </button>
            <button
                    v-on:click="cancel"
                    class="btn btn-default">
                {{ 'Cancel' | trans }}
            </button>
        </span>
    </div>
</template>

<script>
    import moment from 'moment';
    import ZoneSelector from '../Zone/ZoneSelector';

    export default {
        components: {ZoneSelector},
        props: {
            hourData: Object,
            date: String,
            hourNumber: Number,
            isBoundOfDay: Boolean,
            disabled: Boolean,
            user: Object
        },
        data() {
            return {
                confirmationShown: false
            }
        },
        methods: {
            onToggleInput(available) {
                if (this.hourData.jobScheduled === true && available === false) {
                    this.confirmationShown = true;
                    return;
                }
                const hourDataUpdated = {...this.hourData};
                hourDataUpdated.available = available;
                if (available === true) {
                    hourDataUpdated.zoneId = null;
                }
                this.$emit('hourData:updated', hourDataUpdated);
            },
            confirm() {
                this.confirmationShown = false;
                const hourDataUpdated = {...this.hourData};
                hourDataUpdated.available = false;
                this.$emit('hourData:updated', hourDataUpdated);
            },
            cancel() {
                this.confirmationShown = false;
            },
            onZoneIdInput(zoneId) {
                const hourDataUpdated = {...this.hourData};
                hourDataUpdated.zoneId = zoneId;
                this.$emit('hourData:updated', hourDataUpdated);
            }
        },
        computed: {
            warningMessage() {
                let message = this.$options.filters.trans('Warning, there are already jobs scheduled on this slot!');
                if (this.isShortTimingSlot) {
                    message += ' ' + this.$options.filters.trans(`Si vous fermez ce créneau horaire, cela représentera des frais d'annulation.`);
                }
                return message;
            },
            confirmationMessage() {
                return this.warningMessage + ' ' + this.$options.filters.trans('Are you sure you want to close it?');
            },
            isShortTimingSlot() {
                return moment(this.date + ' ' + this.hourNumber + ':00').isBefore(moment().add(12, 'hour'));
            },
            zipCodeInputPlaceholder() {
                return this.isBoundOfDay ? this.user.workerZipCode : this.$options.filters.trans('zip');
            }
        },
    }
</script>

<style scoped lang="scss">
    .flash {
        background: #ff6868;
        border-radius: 5px;
    }
    .hour-label {
        display: inline-block;
        width: 80px;
    }
    .warning-icon {
        margin-left: 20px;
        color: red;
    }
    button {
        margin-right: 10px;
        padding: 4px 13px;
        border-radius: 4px;
    }
    input {
        margin-left: 25px;
        width: 100px;
    }
    input::placeholder {
        color: #bdbdbd;
        opacity: 1;
    }
    >>> .zone-content {
        width: 55%;
        display: inline-block;
        margin-left: 5px;
        font-size: 12px;
        .btn-primary:first-child {
            overflow: hidden;
            width: 120px;
            text-overflow: ellipsis;
        }
        .btn-primary {
            font-size: 12px;
        }
    }
</style>